import "./styles.scss";

import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getDisclosureAffiliate } from "../../../store/middleware/affiliate.middleware";

const I18NEXT_TO_API_LANGUAGE = { en: "EN", es: "ES", pt: "PT", fr: "FR" };

const getApiLanguage = (i18nextLanguage) => I18NEXT_TO_API_LANGUAGE[i18nextLanguage] ?? "EN";

const groupActiveItemsByTitle = (data) =>
  data
    .filter((item) => item.active)
    .reduce((acc, item) => {
      if (!acc[item.title]) acc[item.title] = { order: item.order, content: [] };
      acc[item.title].content.push({ menu: item.menu, language: item.language, active: item.active });
      return acc;
    }, {});

const findByLanguage = (items, apiLanguage) => items.find((item) => item.language === apiLanguage);

function Disclosure() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const apiLanguage = getApiLanguage(language);

  const [menuByTitle, setMenuByTitle] = useState({});
  const [contentItems, setContentItems] = useState([]);
  const [activeNavIndex, setActiveNavIndex] = useState(0);

  const loadDisclosureData = async (index) => {
    const responseTitle = await dispatch(getDisclosureAffiliate("", true));
    const responseMenu = await dispatch(getDisclosureAffiliate("", false));
    const responseContent = await dispatch(getDisclosureAffiliate("", false, responseTitle[index]?.title));

    setMenuByTitle(groupActiveItemsByTitle(responseMenu));
    setContentItems(responseContent.filter((item) => item.active));
  };

  useEffect(() => {
    loadDisclosureData(0);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="containerDisclosure">
      <h2 className="title">{t("DISCLOSURE")}</h2>

      <nav className="wrapperNavBarDisclosure">
        {Object.entries(menuByTitle)
          .sort((a, b) => a[1].order - b[1].order)
          .map(([title, items], i) => (
            <button
              key={title + i}
              className={`itemNavBarDisclosure ${activeNavIndex === i && "active"}`}
              onClick={() => {
                loadDisclosureData(i);
                setActiveNavIndex(i);
              }}
            >
              {findByLanguage(items.content, apiLanguage)?.menu}
            </button>
          ))}
      </nav>

      <div
        className="contentDisclosure"
        dangerouslySetInnerHTML={{
          __html: findByLanguage(contentItems, apiLanguage)?.content,
        }}
      ></div>
    </div>
  );
}

export default Disclosure;
